import axios from "axios";

const api = axios.create({ baseURL: process.env.REACT_APP_API_VIA_CEP });

export const addresses = {
  select: zipcode => api.get(`/ws/${zipcode}/json`)
};
